export default __webpack_public_path__ + "static/media/s2.f7828449.jpg";